import {
  IUserActionTypes,
  ImpersonateUserParams,
  IMPERSONATE_USER
} from 'types';
import { all, takeLatest, call, put } from 'redux-saga/effects';
import Services from 'services';
import { fetchAppSuccess, initAppFailure } from 'redux/app/actions';
import { fetchIUserFailure, fetchIUserSuccess } from './actions';

export function* handleFetchIUser(req: any) {
  const { userId, organisationId }: ImpersonateUserParams = req.payload;
  try {
    const res = yield call(
      Services.user.fetchImpersonateUser,
      userId,
      organisationId
    );
    if (!res.error) {
      sessionStorage.setItem(
        IMPERSONATE_USER.SESSION_NAME,
        JSON.stringify(res)
      );
      yield put(fetchIUserSuccess(res));
      yield put(fetchAppSuccess());
      window.location.reload();
    } else {
      yield put(fetchIUserFailure(res.error.message));
      yield put(initAppFailure());
    }
  } catch (error) {
    const errorMsg = error.message ? error.message : error;
    yield put(fetchIUserFailure(errorMsg));
    yield put(initAppFailure());
  }
}

export function* watchFetchIUser() {
  yield takeLatest(IUserActionTypes.FETCH_IUSER_START, handleFetchIUser);
}

export function* impersonateUser() {
  yield all([call(watchFetchIUser)]);
}

export default impersonateUser;
